import {
  ActiveBodyTemplate,
  AlcTypeBodyTemplate,
  AttachmentCategoryBodyTemplate,
  AttachmentStatusBodyTemplate,
  BooleanBodyTemplate,
  DateBodyTemplate,
  DecimalBodyTemplate,
  DelForProcessBodyTemplate,
  DelForProcessIsActiveBodyTemplate,
  DeliveryStatusBodyTemplate,
  DeliveryTypeBodyTemplate,
  ForecastDateBodyTemplate,
  NumberBodyTemplate,
  OrderProcessBodyTemplate,
  OrderProcessIsActiveBodyTemplate,
  PackagingIdentifierBodyTemplate,
  PackagingTypeBodyTemplate,
  PercentBodyTemplate,
  PriceBodyTemplate,
  PropertyIdentifierBodyTemplate,
  StatusBodyTemplate,
  WeightUnitBodyTemplate,
} from '../../../../components/tableTemplates'
import { ColumnConfig } from '../../../../features/ui-config'

export function getBodyTemplate(
  dataType: ColumnConfig['dataType'],
  value: any,
  rowData: any,
) {
  switch (dataType) {
    case 'active':
      return ActiveBodyTemplate(
        value,
        rowData.projectName === null || rowData.projectName === ''
          ? false
          : true,
      )
    case 'alcType':
      return AlcTypeBodyTemplate(value)
    case 'attachmentCategory':
      return AttachmentCategoryBodyTemplate(value)
    case 'attachmentStatus':
      return AttachmentStatusBodyTemplate(value)
    case 'boolean':
      return BooleanBodyTemplate(value)
    case 'date':
      return DateBodyTemplate(value)
    case 'decimal':
      return DecimalBodyTemplate(value)
    case 'delForProcessCompletion':
      return DelForProcessBodyTemplate(value, 20)
    case 'delForProcessIsActive':
      return DelForProcessIsActiveBodyTemplate(
        value,
        rowData.DelForProcess.IsActive,
        20,
      )
    case 'deliveryStatus':
      return DeliveryStatusBodyTemplate(value)
    case 'deliveryType':
      return DeliveryTypeBodyTemplate(value)
    case 'forecastDate':
      return ForecastDateBodyTemplate(value, rowData.DateFormat)
    case 'number':
      return NumberBodyTemplate(value)
    case 'orderProcessCompletion':
      return OrderProcessBodyTemplate(value, 20)
    case 'orderProcessIsActive':
      return OrderProcessIsActiveBodyTemplate(
        value,
        rowData.OrderProcess.IsActive,
        20,
      )
    case 'packagingIdentifier':
      return PackagingIdentifierBodyTemplate(value)
    case 'packagingType':
      return PackagingTypeBodyTemplate(value)
    case 'percent':
      return PercentBodyTemplate(value)
    case 'price':
      return PriceBodyTemplate(value)
    case 'propertyIdentifier':
      return PropertyIdentifierBodyTemplate(value)
    case 'status':
      return StatusBodyTemplate(value)
    case 'unitOfWeight':
      return WeightUnitBodyTemplate(value)
    case 'currency':
    case 'day':
    case 'project':
    case 'role':
    case 'string':
    default:
      return <>{value}</>
  }
}
